export const ID = 'e5a5c1e4-4550-400e-a388-5ff6cfb34c3c';

export const NAME = 'Blog Post';
